import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vShow as _vShow, renderList as _renderList, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "splash-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center text-white mb-4" }, "Request Login", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-success text-center" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "alert-heading" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" }),
    /*#__PURE__*/_createTextVNode("  Request successfully submitted! ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "We'll get back to you as soon as we can.")
], -1)
const _hoisted_4 = { class: "text-center mt-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-left" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("  Back to home ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, " All communications regarding access to the ADHE site must be sent from your school’s email address. ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "text-white" }, "Contact Information", -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12 col-lg-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label text-white" }, "First Name", -1)
const _hoisted_13 = { class: "col-12 col-lg-6" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label text-white" }, "Last Name", -1)
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label text-white" }, "Title", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", { class: "text-white" }, "Account Type", -1)
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "form-label" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "College",
  class: "text-white"
}, "College Financial Aid Office", -1)
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "form-label" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  for: "HighSchool",
  class: "text-white"
}, "High School Counselor", -1)
const _hoisted_31 = { class: "col-12" }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "form-label text-white" }, "Address", -1)
const _hoisted_34 = { class: "col-12 col-lg-4" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "form-label text-white" }, "City", -1)
const _hoisted_37 = { class: "col-12 col-lg-4" }
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "form-label text-white" }, "State", -1)
const _hoisted_40 = { class: "col-12 col-lg-4" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "form-label text-white" }, "Zip", -1)
const _hoisted_43 = { class: "col-12" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "form-label text-white" }, "Phone", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h3", { class: "text-white" }, "Login Information", -1)
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "form-label text-white" }, "Email", -1)
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "form-label text-white" }, "Confirm Email", -1)
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "form-label text-white" }, "Notes (Optional)", -1)
const _hoisted_53 = { class: "text-center" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createTextVNode("   Submit ")
const _hoisted_56 = [
  _hoisted_54,
  _hoisted_55
]
const _hoisted_57 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createTextVNode("  Cancel ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.isSubmitted)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "/login",
              class: "btn btn-lg btn-dark"
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_7,
          _createElementVNode("section", null, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.contactFirstName = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.contactFirstName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.contactLastName = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.contactLastName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.contactTitle = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.contactTitle]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("section", null, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      id: "College",
                      type: "checkbox",
                      name: "college",
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.accountIsCollegeFA = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.accountIsCollegeFA]
                    ]),
                    _hoisted_24,
                    _hoisted_25
                  ]),
                  _withDirectives(_createVNode(_component_multiselect, {
                    modelValue: _ctx.accountSelectedColleges,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.accountSelectedColleges = $event)),
                    options: _ctx.metadataStore.colleges,
                    multiple: true,
                    searchable: true,
                    "close-on-select": false,
                    "track-by": "name",
                    label: "name",
                    placeholder: "Select colleges"
                  }, null, 8, ["modelValue", "options"]), [
                    [_vShow, _ctx.accountIsCollegeFA]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _withDirectives(_createElementVNode("input", {
                      id: "HighSchool",
                      type: "checkbox",
                      name: "highschool",
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.accountIsHighSchool = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.accountIsHighSchool]
                    ]),
                    _hoisted_29,
                    _hoisted_30
                  ]),
                  _withDirectives(_createVNode(_component_multiselect, {
                    modelValue: _ctx.accountSelectedHighSchools,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.accountSelectedHighSchools = $event)),
                    options: _ctx.metadataStore.highSchools || [],
                    multiple: true,
                    searchable: true,
                    "close-on-select": false,
                    "track-by": "name",
                    label: "name",
                    placeholder: "Select high schools"
                  }, null, 8, ["modelValue", "options"]), [
                    [_vShow, _ctx.accountIsHighSchool]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.accountAddress = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.accountAddress]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.accountCity = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.accountCity]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.accountState = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metadataStore.metadata?.states, (state) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: state.abbreviation
                      }, _toDisplayString(`${state?.abbreviation} - ${state?.name}`), 1))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.accountState]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.accountZip = $event))
                  }, null, 512), [
                    [_directive_maska, ['#####', '#####-####']],
                    [_vModelText, _ctx.accountZip]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.accountPhone = $event))
                  }, null, 512), [
                    [_directive_maska, '(###) ###-####'],
                    [_vModelText, _ctx.accountPhone]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("section", null, [
            _hoisted_46,
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _withDirectives(_createElementVNode("input", {
                type: "email",
                class: "form-control",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.loginEmail = $event))
              }, null, 512), [
                [_vModelText, _ctx.loginEmail]
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _withDirectives(_createElementVNode("input", {
                type: "email",
                class: "form-control",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.loginConfirmEmail = $event))
              }, null, 512), [
                [_vModelText, _ctx.loginConfirmEmail]
              ])
            ])
          ]),
          _createElementVNode("section", null, [
            _createElementVNode("div", _hoisted_51, [
              _hoisted_52,
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                rows: "10",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.notes = $event))
              }, null, 512), [
                [_vModelText, _ctx.notes]
              ])
            ])
          ]),
          _createElementVNode("p", _hoisted_53, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-success btn-lg",
              onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.submitRequest && _ctx.submitRequest(...args)))
            }, _hoisted_56),
            _hoisted_57,
            _createVNode(_component_router_link, {
              to: "/login",
              class: "btn btn-lg btn-dark"
            }, {
              default: _withCtx(() => [
                _hoisted_58,
                _hoisted_59
              ]),
              _: 1
            })
          ])
        ], 64))
  ]))
}